import { Cookie } from '@atlassiansox/asc-core';

import { HamletProduct } from './models';

export type GetCartRequest = {
  readonly cartId: string;
};

export type PatchUserRequest = {
  readonly cloudSessionTokenCookie: Cookie;
  readonly firstName: string;
  readonly lastName: string;
};

export type GetXsrfTokenRequest = {
  readonly cloudSessionTokenCookie: Cookie;
};

export type GetEmailExistsRequest = {
  readonly email: string;
};

export type GetEmailExistsResponse =
  | SuccessfulGetEmailExistsResponse
  | UnsuccessfulGetEmailExistsResponse;

export type SuccessfulGetEmailExistsResponse = {
  readonly message: string;
  readonly success: true;
};

export type UnsuccessfulGetEmailExistsResponse = {
  readonly message: null;
  readonly success: false;
};

export type GetProductPricingRequest = {
  readonly productKeys: readonly string[];
  readonly licenseType?: string;
  readonly monthsValid?: string | number;
  readonly requestingApplication?: string;
};

export type GetProductPricingResponse = {
  readonly currency: string;
  readonly products: readonly HamletProduct[];
};
